export default "__VITE_ASSET__Dwy2ZTaA__"